import Link from 'next/link';

import styles from '@/components/agents/agents.module.css';

import clsxm from '@/lib/clsxm';

import { ArrowGlyph, Stage } from '@/components/agents/primitives';

import { Avatar, COMPANY, TEAM, useB2bTranslation } from './kit';

export default function TeamsFinalCta() {
  const { t } = useB2bTranslation();

  const joins = [
    { person: TEAM.daniel, when: t('2 min ago') },
    { person: TEAM.sofia, when: t('5 min ago') },
    { person: TEAM.arjun, when: t('12 min ago') },
  ];

  return (
    <section className='mx-auto max-w-7xl px-3 pb-24 pt-8 sm:px-6 sm:pb-32 lg:px-8'>
      <Stage
        variant='indigo'
        halftoneAt='100% 100%'
        className='px-6 py-16 sm:px-14 sm:py-24'
      >
        <div className='relative grid items-center gap-14 lg:grid-cols-[1.7fr_1fr]'>
          <div>
            <h2
              className={clsxm(
                styles.display,
                'text-[2.25rem] font-semibold leading-[1.06] text-white sm:text-5xl lg:text-[3.5rem]',
              )}
            >
              {t('Bring your whole team into one AI workspace.')}
            </h2>
            <p className='mt-6 max-w-lg text-lg leading-8 text-primary-100'>
              {t('Set up in minutes. Invite your team today.')}
            </p>
            <div className='mt-10 flex flex-wrap items-center gap-3'>
              <a
                href='#pricing'
                className='inline-flex items-center justify-center gap-2 rounded-full bg-white px-6 py-3.5 text-[15px] font-semibold text-primary-700 shadow-[0_10px_30px_-10px_rgba(20,10,80,0.6)] transition-colors duration-200 hover:bg-primary-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white'
              >
                {t('See team plans')}
                <ArrowGlyph />
              </a>
              <Link
                href='/contact'
                className='inline-flex items-center justify-center gap-2 rounded-full px-6 py-3.5 text-[15px] font-semibold text-white ring-1 ring-inset ring-white/35 transition duration-200 hover:bg-white/10 hover:ring-white/60 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white'
              >
                {t('Talk to sales')}
              </Link>
            </div>
          </div>

          <div aria-hidden='true' className='hidden lg:block'>
            <div className={clsxm(styles.float, 'ms-auto max-w-sm space-y-3')}>
              {joins.map(({ person, when }, index) => (
                <div
                  key={person.name}
                  className={clsxm(
                    'flex items-center gap-3 rounded-2xl px-4 py-3 shadow-[0_20px_40px_-20px_rgba(20,10,80,0.6)]',
                    index === 0
                      ? 'bg-white text-[#10101c]'
                      : 'bg-white/15 text-white ring-1 ring-inset ring-white/20',
                    index === 1 && 'ms-6',
                    index === 2 && 'ms-12',
                  )}
                >
                  <Avatar person={person} />
                  <span className='min-w-0 flex-1'>
                    <span className='block truncate text-[14px] font-semibold'>
                      {t('{{name}} joined {{company}}', {
                        name: person.name.split(' ')[0],
                        company: COMPANY,
                      })}
                    </span>
                    <span
                      className={clsxm(
                        'block text-xs',
                        index === 0 ? 'text-[#6f6f86]' : 'text-primary-100',
                      )}
                    >
                      {when}
                    </span>
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </Stage>
    </section>
  );
}
